import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'url-search-params-polyfill'

import { createApp, Plugin } from 'vue'

// Plugins
import VueLoaders from 'vue-loaders'
import VueScrollTo from 'vue-scrollto'
import FloatingVue, { VTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// Bugsnag
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

// Common utilities & mixins
import { setupJsCommon } from '@internetworkexpert/js-common'
import { mixpanelEvent } from '@/helpers/mixins'

// Custom directive
import followTooltip from '@/components/shared/followTooltipDirective'
import store from './store'
import App from './App.vue'
import router from './router'

// —————————————————————————————————————————————————————————————————————————————
// 1) Initialize Bugsnag *before* mounting
Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_KEY || '',
  releaseStage: process.env.VUE_APP_ENVIRONMENT,
  plugins: [new BugsnagPluginVue()],
  autoDetectErrors: false,
  enabledReleaseStages: ['production', 'staging', 'development'],
  appVersion: '2.128.0',
})
const bugsnagVue = Bugsnag.getPlugin('vue')

// 2) Setup common helpers
setupJsCommon(process.env.VUE_APP_ENVIRONMENT || 'production')

// GA4/Ads via GTM: ensure dataLayer exists (no UA/gtag usage here)
declare global {
  interface Window {
    dataLayer: any
  }
}
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || []
}

// 3) Create the Vue 3 application
const app = createApp(App)

// 4) Install router & store
app.use(store)
app.use(router)

// 5) Install Bugsnag Vue plugin
const bugsnagVuePlugin = bugsnagVue as Plugin
app.use(bugsnagVuePlugin)

// 6) Install other plugins
app.use(VueLoaders)
app.use(VueScrollTo)
app.component('v-select', vSelect)
app.use(FloatingVue, {
  // Global defaults (optional)
  delay: { show: 100, hide: 50 },
  // Define your custom themes
  themes: {
    // Custom tooltip
    ine: {
      // Inherit all "tooltip" behaviors
      $extend: 'tooltip',
      triggers: ['hover', 'focus'],
      html: true, // allow HTML content
      // You can also tweak: distance, delay, placement, arrowOverflow, etc.
    },
    // Custom popover example
    // 'ine-popover': {
    //   $extend: 'popover',
    //   triggers: ['click'],
    //   html: true,
    //   placement: 'bottom-start',
    // },
  },
})

// 7) Global mixin for Mixpanel events
app.mixin(mixpanelEvent)

// 8) Register directives & components
app.directive('follow-tooltip', followTooltip)
app.directive('tooltip', VTooltip)

// 9) Mount the app
app.mount('#app')
